import {makeEnumTypeGuard} from '../../../../../libs/shared/helpers/src/typescript/enumHelpers';

export enum TransformerIdsEnum {
  GET = 'get',
  FUNCTION_START = 'function_start',
  COMPARE = 'compare',
  CAPITALIZE = 'capitalize',
  SUBSTRING = 'substring',
  EXTRACT_URLS = 'extract_urls',
  EXTRACT_EMAILS = 'extract_emails',
  EXTRACT_TEXT = 'extract_text',
  SPLIT = 'split',
  TO_NUMBER = 'to_number',
  TO_EMAIL = 'to_email',
  TO_URL = 'to_url',
  TO_INBOX = 'to_inbox',
  TO_JSON = 'to_json',
  TO_TAG = 'to_tag',
  TO_TEAMMATE = 'to_teammate',
  TO_CONTACT = 'to_contact',
  FORMAT = 'format',
  TO_ISO8601 = 'to_iso8601',
  TO_UNIX_TIMESTAMP = 'to_unix_timestamp',
  DOMAIN_TO_ACCOUNT = 'domain_to_account',
  TO_UPPERCASE = 'to_uppercase',
  TO_LOWERCASE = 'to_lowercase',
  GET_QUERY_PARAM = 'get_query_param',
  ADD = 'add',
  SUBTRACT = 'subtract',
  START_OF = 'start_of',
  END_OF = 'end_of',
  FIRST = 'first',
  LAST = 'last',
  NTH = 'nth',
  BEGINNING = 'beginning',
  END = 'end',
  FILTER = 'filter',
  MAP = 'map',
  FIND = 'find',
  SORT_BY = 'sort_by',
  DEDUP = 'dedup',
  JOIN = 'join',
  GET_CUSTOM_FIELD = 'get_custom_field',
  IS_UNDEFINED = 'is_undefined',
  IS_DEFINED = 'is_defined',
  GET_RECIPIENTS = 'get_recipients',
  DETECT_LANGUAGE = 'detect_language',
  GET_MESSAGE_BODY = 'get_message_body',
  GET_JSON_PROPERTY = 'get_json_property',
  AS_ARRAY = 'as_array',
  AS_STRING = 'as_string',
  AS_NUMBER = 'as_number',
  AS_BOOLEAN = 'as_boolean',
  FETCH = 'fetch',
  GET_HEADER = 'get_header',
  GET_CIRCLE = 'get_circle',
  GET_COLUMN_VALUE = 'get_column_value',
  CREATE_STRING = 'create_string',
  CREATE_URL = 'create_url',
  CREATE_TEAMMATE_LIST = 'create_teammate_list',
  USE_PREVIOUS = 'use_previous',
}

export const isTransformerId = makeEnumTypeGuard(TransformerIdsEnum);
